import React from 'react';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import {
  AppStoreBadge,
  AppStoreBadgeContainer
} from '@/components/AppStoreBadge/AppStoreBadge';
import {
  StyledHeroBrandedContainer,
  StyledAppStoreBadgeContainer,
  Wrapper
} from './HeroBrandedRebrand.styled';
import { Typography } from '@latitude/typography';

const COMPONENT_ID = 'hero-branded-rebrand';

/**
 * HeroBrandedRebrand component
 */
const HeroBranded = ({ heading, subTitle, trackingId, ...rest }) => {
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;

  return (
    <Wrapper className={componentIdentifier} {...rest}>
    <StyledHeroBrandedContainer>
      <Typography.H4 color={REBRAND_COLOR.WHITE}>{heading}</Typography.H4>
      {subTitle && (
        <Typography.SH1 color={REBRAND_COLOR.WHITE} className="mt-3">
          {subTitle}
        </Typography.SH1>
      )}

      <StyledAppStoreBadgeContainer
        className={`${componentIdentifier}-badge-container`}
      >
        <AnalyticsLocationProvider location="hero-branded-rebrand">
          <AppStoreBadgeContainer>
            <AppStoreBadge url="https://apps.apple.com/app/apple-store/id1373059866" />
            <AppStoreBadge url="https://play.google.com/store/apps/details?id=com.latitudefinancial.latitudeapp" />
          </AppStoreBadgeContainer>
        </AnalyticsLocationProvider>
      </StyledAppStoreBadgeContainer>
    </StyledHeroBrandedContainer>
    </Wrapper>
  );
};

export default HeroBranded;
